import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditRouteService } from '../../../../../../services';

@Component({
  selector: 'app-replace-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './replace-button.component.html',
  styleUrls: ['./replace-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReplaceButtonComponent {
  public replacePointClickEmitter = output<void>();
  private _editRouteService = inject(EditRouteService);
  public isLoadingResourcesOnExistingItem = computed(() => this._editRouteService.isLoadingResourcesOnExistingItem());
  
  public handleReplacePointClick() {
    this._editRouteService.setIsLoadingResourcesOnExistingItem(true);
    this.replacePointClickEmitter.emit();
  }
}
